import { Fragment } from "react";

import { Box, Divider, Paper, Typography, useTheme } from "@mui/material";
import { ChartsLabelMark, ChartsTooltipContainer, ChartsTooltipProps, useAxesTooltip } from "@mui/x-charts";

import { getUnitUsageColor, getUnitValueLabel } from "~/utils/unitUsageHelpers";
import { TotalUsageType } from "./DashboardPPTCharts";

const TotalUsageTooltip = ({
  hideExpectedUsage,
  unitLabel = "",
  totalUsage,
  ...props
}: ChartsTooltipProps & { hideExpectedUsage?: boolean; unitLabel: string; totalUsage: TotalUsageType }) => {
  const theme = useTheme();
  const axesTooltipData = useAxesTooltip();

  if (!totalUsage) {
    return null;
  }

  const { axisFormattedValue, seriesItems } = axesTooltipData?.[0] || {};

  return (
    <ChartsTooltipContainer {...props}>
      <Paper>
        <Box alignItems="center">
          <Typography p={1} pb={0.5}>
            {axisFormattedValue}
          </Typography>
          <Divider sx={{ mb: 0.5 }} />
          <Box alignItems="center" display="grid" gridTemplateColumns="auto 1fr auto" px={2} sx={{ gridColumnGap: theme.spacing(3) }}>
            {seriesItems?.map((item) => {
              const { color: origColor, formattedLabel, formattedValue, seriesId, markType, value } = item;

              let color = origColor;
              if (seriesId === "usedUnits") {
                const rawColor = getUnitUsageColor(totalUsage.unitUsagePercentage, theme);
                color = typeof rawColor === "function" ? rawColor(theme) : rawColor;
              }

              return (
                <Fragment key={seriesId}>
                  <ChartsLabelMark color={color} type={markType} />
                  <Typography sx={{ display: "inline-block" }}>{`${formattedLabel}`}</Typography>
                  <Typography sx={{ display: "inline-block" }}>{getUnitValueLabel(formattedValue, unitLabel, value)}</Typography>
                </Fragment>
              );
            })}
            {!hideExpectedUsage && (
              <>
                <ChartsLabelMark color={theme.palette.error.main} type="line" />
                <Typography sx={{ display: "inline-block" }}>Expected Usage</Typography>
                <Typography sx={{ display: "inline-block" }}>{getUnitValueLabel(totalUsage.forecast, unitLabel)}</Typography>
              </>
            )}
          </Box>
        </Box>
      </Paper>
    </ChartsTooltipContainer>
  );
};

export default TotalUsageTooltip;
